import API from '../../Services/API';

class TwilioService {
    constructor() {
        this.client = null;
        this.isInitialized = false;
        this.token = null;
    }

    async getToken() {
        try {
            const tokenData = await API.get('auth/voipToken');
            return tokenData.token;
        } catch (error) {
            console.error('Failed to fetch Twilio token:', error);
            throw error;
        }
    }

    async initialize() {
        if (this.isInitialized) {
            return this.client;
        }

        try {
            console.log('Initializing Twilio');

            const { Device } = await import('@twilio/voice-sdk');

            // Fetch initial token
            this.token = await this.getToken();

            // Initialize Twilio Device with the token
            this.client = new Device(this.token, {
                closeProtection: true,
                enableRingingState: true,
            });

            // Set up event listeners
            this.setupEventListeners();

            console.log('Twilio Device initialized');

            this.isInitialized = true;
            return this.client;
        } catch (error) {
            console.error('Failed to initialize Twilio Voice SDK:', error);
            throw error;
        }
    }

    setupEventListeners() {
        if (!this.client) return;

        this.client.on('ready', () => {
            console.log('Twilio Device is ready');
        });

        this.client.on('error', (error) => {
            console.error('Twilio Device error:', error);
        });

        this.client.on('connect', (connection) => {
            console.log('Call connected:', connection);
        });

        this.client.on('disconnect', (connection) => {
            console.log('Call disconnected:', connection);
        });

        this.client.on('incoming', (connection) => {
            console.log('Incoming call:', connection);
        });

        this.client.on('tokenWillExpire', async () => {
            console.log('Token will expire, refreshing...');
            try {
                const newToken = await this.getToken();
                this.token = newToken;
                this.client.updateToken(newToken);
                console.log('Token refreshed successfully');
            } catch (error) {
                console.error('Failed to refresh token:', error);
            }
        });
    }

    getClient() {
        return this.client;
    }

    isReady() {
        return this.isInitialized && this.client !== null;
    }

    getCurrentToken() {
        return this.token;
    }
}

// Singleton instance
const twilioService = new TwilioService();

export default twilioService;
